import domain1 from "../Assests/OurDomainImages/domain1.png";
import domain2 from "../Assests/OurDomainImages/domain2.png";
import domain3 from "../Assests/OurDomainImages/domain3.png";
import domain4 from "../Assests/OurDomainImages/domain4.png";
import domain5 from "../Assests/OurDomainImages/domain5.png";
import domain6 from "../Assests/OurDomainImages/domain6.png";
import domain7 from "../Assests/OurDomainImages/domain7.png";
import tower from "../Assests/OurDomainImages/tower.png";
import bank from "../Assests/OurDomainImages/bank.png";
import coding from "../Assests/OurDomainImages/coding.png";
import blockchain from "../Assests/OurDomainImages/blockchain.png";
import departures from "../Assests/OurDomainImages/departures.png";
import heart from "../Assests/OurDomainImages/heart.png";
import wheel from "../Assests/OurDomainImages/wheel.png";

export const domainPageData = [
  {
    img: domain1,
    icon: coding,
    heading: "Software & Technology",
    subHeading:
      "Empowering Your Business with Cutting-Edge Software & Technology Solutions",
    points: [
      {
        pointA: "Comprehensive Software Solutions",
        pointB: "Harnessing Advanced Technologies",
        pointC: "Seamless Infrastructure Support",
        pointD: "Tailored Solutions for Your Success",
        pointE: "Trustworthy Partners in Progress",
      },
    ],
  },
  {
    img: domain2,
    icon: tower,
    heading: "Telecommunication",
    subHeading:
      "Connecting the World through Advanced Telecommunication Services",
    points: [
      {
        pointA: "Expert Network Design and Maintenance",
        pointB: "Advancing Wireless Communication Technologies",
        pointC: "Satellite Networks for Global Connectivity",
        pointD: "Secure and Efficient Telecommunications",
        pointE: "Empowering the World with Information",
      },
    ],
  },
  {
    img: domain3,
    icon: wheel,
    heading: "Automotive",
    subHeading: "Driving Automotive Excellence through Technical Expertise",
    points: [
      {
        pointA: "Cutting-Edge Automotive Design",
        pointB: "Streamlined Manufacturing with Automation",
        pointC: "Rigorous Quality Control",
        pointD: "Diagnostic Solutions for Reliable Maintenance",
        pointE: "Embracing the Future of Automotive Innovation",
      },
    ],
  },
  {
    img: domain4,
    icon: bank,
    heading: "Banking & Finance",
    subHeading: "Empowering Financial Success through Technical Excellence",
    points: [
      {
        pointA: "Efficient Financial Management Software",
        pointB: "Robust Risk Assessment and Management",
        pointC: "Compliant Operations with Regulatory Solutions",
        pointD: "Data-Driven Insights for Enhanced Performance",
        pointE: "Pioneering the Future of Finance",
      },
    ],
  },
  {
    img: domain5,
    icon: heart,
    heading: "Healthcare",
    subHeading: "Transforming Healthcare with Advanced Technical Solutions",
    points: [
      {
        pointA: "Electronic Health Records (EHRs) for Seamless Patient Care",
        pointB: "Telemedicine for Remote Medical Services",
        pointC: "Cutting-Edge Medical Imaging Technologies",
        pointD: "Research and Development with Big Data Analytics",
        pointE: "Leading the Way in Advancing Healthcare Solutions",
      },
    ],
  },
  {
    img: domain6,
    icon: blockchain,
    heading: "Blockchain ",
    subHeading:
      "Unlocking the Potential of Blockchain with Expert Technical Solutions",
    points: [
      {
        pointA: "Seamless Node Hosting and Maintenance",
        pointB: "Cutting-Edge Blockchain Development",
        pointC: "Expert Blockchain Consulting",
        pointD: "Robust Security Audits",
        pointE: "Ensuring Interoperability and Integration",
      },
    ],
  },
  {
    img: domain7,
    icon: departures,
    heading: "Airlines",
    subHeading: "Elevating Airlines with Tailored Technical Solutions",
    points: [
      {
        pointA: "Seamless Flight Operations Support",
        pointB: "Reliable Maintenance, Repair, and Overhaul (MRO)",
        pointC: "Enhancing Passenger Services",
        pointD: "Data-Driven Decisions with Analytics",
        pointE:
          "Robust Cybersecurity Measures and Seamlessly Integrated Systems",
      },
    ],
  },
];
